import React, { Component } from 'react';
import { Modal as BModal } from 'react-bootstrap';
import { Button, SelectSearch, Table, Icon, Input } from '../../../../components';
import { Globals, Constants } from '../../../../utils';
import axios from '../../../../utils/axios';

class ModalProductLimited extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            selected_product: null,
            max_quantity: '',
            products_list: [], // [{ product_id, product_name, product_code, max_quantity }]

            all_products: [],
            loading: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.loadSelects();
            if (this.props.data) {
                // Modo Edición
                const item = this.props.data;
                this.setState({
                    id: item.id,
                    products_list: [{
                        product_id: item.product_id,
                        product_name: item.product ? item.product.name : 'Desconocido',
                        product_code: item.product ? item.product.code : '',
                        max_quantity: item.max_quantity,
                        decimal_stock: item.product ? item.product.decimal_stock : null
                    }],
                    selected_product: null,
                    max_quantity: ''
                });
            } else {
                // Modo Creación
                this.setState({
                    id: null,
                    products_list: [],
                    selected_product: null,
                    max_quantity: ''
                });
            }
        }
    }

    loadSelects = async () => {
        this.setState({ loading: true });
        try {
            const res = await axios.post('admin/discounts/get-selects', { user_id: this.props.user_id });
            if (res.data && res.data.products) {
                this.setState({
                    all_products: res.data.products.map(p => ({
                        value: p.id,
                        label: `${p.name} (${p.code || 'Sin código'})`,
                        code: p.code,
                        name: p.name,
                        product: p
                    })),
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching selects:', error);
            this.setState({ loading: false });
        }
    }

    handleAddProduct = () => {
        const { selected_product, max_quantity, products_list } = this.state;
        if (!selected_product || !selected_product.value) {
            return Globals.showError('Seleccione un producto para agregar');
        }

        const isDecimal = selected_product.product && selected_product.product.decimal_stock == Constants.DECIMAL_STOCK.YES;

        const qty = isDecimal ? parseFloat(max_quantity) : parseInt(max_quantity);
        if (isNaN(qty) || qty <= 0 || (!isDecimal && max_quantity.toString().includes('.'))) {
            return Globals.showError(isDecimal ? 'La cantidad máxima debe ser un número mayor a cero' : 'La cantidad máxima debe ser un entero mayor a cero');
        }

        const exists = products_list.some(p => p.product_id === selected_product.value);
        if (exists) {
            return Globals.showError('El producto ya está en la lista');
        }

        this.setState({
            products_list: [...products_list, {
                product_id: selected_product.value,
                product_name: selected_product.name || (selected_product.product && selected_product.product.name),
                product_code: selected_product.code || (selected_product.product && selected_product.product.code),
                max_quantity: qty,
                decimal_stock: selected_product.product ? selected_product.product.decimal_stock : null
            }],
            selected_product: null,
            max_quantity: ''
        });
    }

    handleRemoveProduct = (index) => {
        const list = [...this.state.products_list];
        list.splice(index, 1);
        this.setState({ products_list: list });
    }

    save = async () => {
        const { id, products_list } = this.state;
        const { user_id, onSuccess, onClose } = this.props;

        if (products_list.length === 0) {
            return Globals.showError('Debe agregar al menos un producto a la lista');
        }

        Globals.setLoading('Guardando...');
        try {
            let res;
            if (id) {
                // Modo Edición: solo toma el primer elemento
                const payload = {
                    id: id,
                    max_quantity: products_list[0].max_quantity
                };
                res = await axios.post('admin/inventory/products-limited/edit', payload);
            } else {
                // Modo Creación: batch
                const payload = {
                    user_id,
                    products: products_list.map(p => ({
                        product_id: p.product_id,
                        max_quantity: p.max_quantity
                    }))
                };
                res = await axios.post('admin/inventory/products-limited/create', payload);
            }

            if (res.data.result) {
                Globals.showSuccess(res.data.message || 'Registro guardado exitosamente');
                if (onSuccess) onSuccess();
                if (onClose) onClose();
            } else {
                Globals.showError(res.data.message || 'Error al guardar');
            }
        } catch (error) {
            console.error('Error saving limited product:', error);
            Globals.showError(error.response?.data?.message || 'Ocurrió un error inesperado al guardar');
        } finally {
            Globals.quitLoading();
        }
    }

    render() {
        const { show, onClose } = this.props;
        const { selected_product, max_quantity, products_list, all_products, loading, id } = this.state;

        return (
            <BModal show={show} onHide={onClose} size="lg" centered>
                <BModal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
                    <BModal.Title style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                        {id ? 'Editar límites de producto por pedido' : 'Agregar límites de producto por pedido'}
                    </BModal.Title>
                </BModal.Header>
                <BModal.Body style={{ paddingTop: 0 }}>

                    {!id && (
                        <div className="row mb-4 align-items-end" style={{ marginTop: '20px' }}>
                            <div className="col-md-5">
                                <SelectSearch
                                    label="Seleccione el (los) producto(s) a limitar"
                                    placeholder={loading ? 'Cargando productos...' : 'Buscar producto por nombre'}
                                    options={all_products}
                                    value={selected_product}
                                    onChange={(data) => this.setState({ selected_product: data })}
                                />
                            </div>
                            <div className="col-md-4">
                                <Input
                                    color=""
                                    className="material"
                                    labelClass="material"
                                    label="Cantidad Máxima por pedido"
                                    type="text"
                                    inputMode={selected_product?.product?.decimal_stock == Constants.DECIMAL_STOCK.YES ? "decimal" : "numeric"}
                                    placeholder="0"
                                    value={max_quantity}
                                    onChange={(e) => {
                                        let val = e.target.value;
                                        const decimal_stock = selected_product?.product?.decimal_stock;
                                        if (decimal_stock == Constants.DECIMAL_STOCK.NO) {
                                            val = val.replace(/\D/g, '');
                                        } else if (decimal_stock == Constants.DECIMAL_STOCK.YES) {
                                            val = val.replace(/[^0-9.]/g, '');
                                            const parts = val.split('.');
                                            if (parts.length > 2) return;
                                        }
                                        this.setState({ max_quantity: val });
                                    }}
                                />
                            </div>
                            <div className="col-md-3">
                                <Button color="primary" onClick={this.handleAddProduct} style={{ borderRadius: '20px', width: '100%' }}>
                                    <Icon name="plus" /> Agregar
                                </Button>
                            </div>
                        </div>
                    )}

                    {products_list.length > 0 && (
                        <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee' }}>
                            <Table
                                header={['Producto', 'Código', 'Cantidad', '']}
                                data={products_list.length}
                                style={{ margin: 0 }}
                            >
                                {products_list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.product_name}</td>
                                        <td>{item.product_code || 'N/A'}</td>
                                        <td>
                                            {id ? (
                                                <input
                                                    type="text"
                                                    inputMode={item.decimal_stock == Constants.DECIMAL_STOCK.YES ? "decimal" : "numeric"}
                                                    className="form-control form-control-sm"
                                                    value={item.max_quantity !== '' && item.decimal_stock == Constants.DECIMAL_STOCK.NO ? parseInt(item.max_quantity) : item.max_quantity}
                                                    style={{ width: '80px' }}
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        if (item.decimal_stock == Constants.DECIMAL_STOCK.NO) {
                                                            val = val.replace(/\D/g, '');
                                                        } else if (item.decimal_stock == Constants.DECIMAL_STOCK.YES) {
                                                            val = val.replace(/[^0-9.]/g, '');
                                                            const parts = val.split('.');
                                                            if (parts.length > 2) return;
                                                        }

                                                        const list = [...products_list];
                                                        list[index].max_quantity = val;
                                                        this.setState({ products_list: list });
                                                    }}
                                                />
                                            ) : (
                                                item.decimal_stock == Constants.DECIMAL_STOCK.NO ? parseInt(item.max_quantity) : parseFloat(item.max_quantity)
                                            )}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            {!id && (
                                                <span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => this.handleRemoveProduct(index)}>
                                                    <Icon name="trash" />
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </Table>
                        </div>
                    )}

                    <div className="d-flex justify-content-center mt-4 mb-2">
                        <Button
                            color="primary"
                            onClick={this.save}
                            style={{ width: '150px' }}
                            disabled={products_list.length === 0}
                        >
                            Guardar
                        </Button>
                    </div>
                </BModal.Body>
            </BModal>
        );
    }
}

export default ModalProductLimited;
